<template>
  <span v-bind:class="$mq">
    <CurrencyAmount v-bind:amount="high_limit" /> /
    <CurrencyAmount v-bind:amount="low_limit" />
  </span>
</template>

<script>
import CurrencyAmount from '../CurrencyAmount.vue'

export default {
  name : 'RippleStateObj',

  components : {CurrencyAmount},

  props : {
    obj : Object
  },

  computed : {
    high_limit : function(){
      return this.obj["HighLimit"];
    },

    low_limit : function(){
      return this.obj["LowLimit"];
    }
  }
}
</script>

<style scoped>
</style>
